import { render, staticRenderFns } from "./ListingCandidates.vue?vue&type=template&id=3c19263c&scoped=true"
import script from "./ListingCandidates.vue?vue&type=script&lang=ts"
export * from "./ListingCandidates.vue?vue&type=script&lang=ts"
import style0 from "./ListingCandidates.vue?vue&type=style&index=0&id=3c19263c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19263c",
  null
  
)

export default component.exports